import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRoles,
  deleteRole,
  updateRole,
  addRole,
  updateRoleVisibility,
} from "store/services/membersAndRoles/roles";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";
// import {  handleAuthError } from "store/middlewares/handleAuthError";

//Get All Cities
export const GetAllRolesAction = createAsyncThunk(
  "roles/getAllRoles",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getRoles(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  }
);

//Delete City
export const DeleteRoleAction = createAsyncThunk(
  "roles/deleteRole",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await deleteRole(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        return fulfillWithValue(payload);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Update City
export const UpdateRoleAction = createAsyncThunk(
  "roles/updateRole",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("tirekicker-admin"));
      const res = await updateRole(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        window.history.go(-1);
        return fulfillWithValue({
          ...res,
          update: payload.id === user?.rolesAndAccess?.roleId,
        });
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Add City
export const AddRoleAction = createAsyncThunk(
  "roles/addRole",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await addRole(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        window.history.go(-1);
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

// Update role visibility
export const UpdateRoleVisibilityAction = createAsyncThunk(
  "roles/updateRoleVisibilityAction",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateRoleVisibility(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
